

const tServerMobile = {
  path: "/ai/mobile",
  name: "tserver",
  redirect: "/mobile_/Mobile_device_manage",
  component: () => import("@/viewsThreeServer/home.vue"),
  children: [
    {
      path: "device_manage/:EID",
      name: "Mobile_device_manage",
      component: () => import("@/viewsThreeServer/deviceManage"),
      meta: { name: "设备流量管理", keepAlive: true }
    },
    {
      path: "deviceLogin/:EID",
      name: "Mobile_device_login",
      component: () => import("@/viewsThreeServer/deviceLogin"),
      meta: { name: "登录", keepAlive: true }
    },
  ]

}
export default tServerMobile;



// WEBPACK FOOTER //
// ./src/router/routerThreeServer.js